import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { Track } from '@platzi/commons';
import { Card, Modal } from '@platzi/ui';
import styles from './ShareModal.module.sass';

const eventsSentSocialMedia = [];

export const ShareModal = (props) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(props.pathToShare);
  const TIME_TO_FEEDBACK_USER = 1000;

  if (!props.showModal || !props.socialNetwork) return null;

  const handleCopyUrl = () => {
    const currentURl = props.pathToShare;

    navigator.clipboard.writeText(currentURl);
    setInputValue(t('escuela.share.copied'));
    setTimeout(() => {
      setInputValue(currentURl);
    }, TIME_TO_FEEDBACK_USER);
  };

  const handleSocialMediaClick = (item) => () => {
    if (props.recordSocialMediaClick && !eventsSentSocialMedia.includes(item.network)) {
      Track.send({
        event: props.recordSocialMediaClick.event,
        route_slug: props.recordSocialMediaClick.route_name,
        network_name: item.network,
      });
      eventsSentSocialMedia.push(item.network);
    }
  };

  return (
    <Modal show={props.showModal} close={() => props.handleShowModal(false)}>
      <Card isDark customClass={styles.Card}>
        <button
          className={styles.CloseModal}
          type="button"
          onClick={() => props.handleShowModal(false)}
          aria-label={t('escuela.share.buttonCloseModal')}
          data-testid="modal"
        >
          <FontAwesomeIcon icon={faTimes} size="sm" />
        </button>
        <div>
          <p>{props.sharedCopy}</p>
          <ul>
            {props.socialNetwork.map((item, index) => (
              <li key={`network-${index}`}>
                <a
                  className={styles[item.class]}
                  onClick={handleSocialMediaClick(item)}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={t('escuela.share.socialNetwork', { network: item.network })}
                >
                  <FontAwesomeIcon icon={item.icon} size="lg" />
                </a>
              </li>
            ))}
          </ul>
          <div className={styles.Input}>
            <input type="text" value={inputValue ? inputValue : props.pathToShare} readOnly />
            <button onClick={handleCopyUrl} aria-label={t('escuela.share.copyUrl')}>
              <FontAwesomeIcon icon={faCopy} />
            </button>
          </div>
        </div>
      </Card>
    </Modal>
  );
};
